import { render, staticRenderFns } from "./AndroidDownloadButton.vue?vue&type=template&id=28d7e6a6"
import script from "./AndroidDownloadButton.vue?vue&type=script&lang=js"
export * from "./AndroidDownloadButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/workspace/Control-Panel/Control-Panel-Preprod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28d7e6a6')) {
      api.createRecord('28d7e6a6', component.options)
    } else {
      api.reload('28d7e6a6', component.options)
    }
    module.hot.accept("./AndroidDownloadButton.vue?vue&type=template&id=28d7e6a6", function () {
      api.rerender('28d7e6a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Utility/AndroidDownloadButton.vue"
export default component.exports